"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Magnifier;

var _Magnifier = require("@adobe/react-spectrum-ui/dist/Magnifier");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Magnifier(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_Magnifier.Magnifier, null));
}